/***
 * @file:
 * @Date: 2020-06-30 09:34:20
 * @author: manyao.zhu
 */
import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { ThemeConfig } from '@ithinkdt/theme/models';

import { defaultLogo } from './default-logo-avatar';

@Component({
  selector: 'dt-header-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  themeConfig: ThemeConfig;

  logoConfig: ThemeConfig;

  @Input() collapsed: boolean;
  @Input() topMenu: boolean;

  hidenProjectName = false;
  originImage = false;

  constructor(private settings: SettingsService, private el: ElementRef) {
    this.themeConfig = this.settings.userConfig['theme'] || {};
    this.logoConfig = this.settings.layout['logoConfig'];
  }

  ngOnInit() {
    // è¿éä¸ºäºå¤çå½logoçå¾å½¢ä¸ä¸ºæ­£æ¹å½¢æ¶ï¼åªå±ç¤ºå¾çï¼æ°æ®æ¥æºäºåç«¯æéç½®ï¼æå»¶è¿ï¼
    setTimeout(() => {
      this.getPicElement();
    }, 300);
  }

  // logoæ¥éæ¶ï¼ä½¿ç¨é»è®¤logo
  imgerror(evt) {
    evt.target.src = defaultLogo;
    evt.target.error = null;
  }

  // è·åçå®å¤§å°çå¾çï¼å¹¶æ ¹æ®å¾çå¤§å°æ¥ç¡®å®æ¯å¦å±ç¤ºç³»ç»åç§°
  getPicElement() {
    const dom = this.el.nativeElement.querySelector('.dt-logo-hiden');
    const height = dom.height;
    const width = dom.width;

    // è¿éä¾æ®å½å¾ççä¸²æ¬¾æ¯ä¾å¤§äº1.5æ¶ï¼å°±å¨é¨å±ç¤ºå¾ç
    if (width / height >= 1.5) {
      this.hidenProjectName = true;
    }
    // å½åå½¢å¾ççå®½é«æ¯ä¾å¨1.5è³4ä¹é´ï¼ä¿æå¾å½¢å®½é«æ¯ä¾ ï¼å®½é«æ¯ä¾å¤§äºæ¯å®½åº¦ä¸º100%ï¼ï¼
    if (width / height >= 1.5 && width / height <= 4) {
      this.originImage = true;
    }
  }
}
